<template>
  <div>
    <b-row>
      <b-col cols="12">
        <cumulatives-filter :get-report-data="getCumulatives" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <b-row>
          <b-col cols="12">
            <stacked-bar
              :series-data="cumulatives.grandTotal.chartData.series"
              :categories-data="cumulatives.grandTotal.chartData.categories"
              title-text="Aylara göre performans"
            />
          </b-col>
          <b-col cols="12">
            <default-card
              title="Genel Toplam"
              :value="cumulatives.grandTotal.sales"
              icon="CheckCircleIcon"
              color="success"
            />
          </b-col>
          <b-col
            v-for="brand in cumulatives.data"
            :key="brand.id"
            cols="12"
            md="4"
          >
            <default-card
              :title="brand.title"
              :value="brand.sales"
              icon="CheckCircleIcon"
              color="success"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import CumulativesFilter from '@/views/Sales/FilterCards/CumulativesFilter.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import StackedBar from '@/layouts/components/ReportCharts/StackedBar.vue'

export default {
  name: 'SalesCumulatives',
  components: {
    LoadingCard,
    CumulativesFilter,
    BRow,
    BCol,
    DefaultCard,
    StackedBar,
  },
  computed: {
    loading() {
      return this.$store.getters['saleReports/loading']
    },
    cumulatives() {
      return this.$store.getters['saleReports/cumulatives']
    },
    cumulativesParams() {
      return this.$store.getters['saleReports/cumulativesParams']
    },
  },
  created() {
    this.getCumulatives()
  },
  methods: {
    getCumulatives() {
      this.$store.dispatch('saleReports/getCumulatives', this.cumulativesParams)
    },
  },
}
</script>
